/**
* @Description:    下载geoJson文件
* @Author:         TSY
* @CreateDate:     2018/9/5 9:04
* @email:          t@tsy6.com
*/
<template>
    <div class="body">
        <div class="echarts"> 
            <div id="map"></div>
            <div id="geo_json">
                <div class="geo_json_title">
                    GeoJson文件
                    <div class="geo_json_copy" @click="copyGeoJson">复制</div>
                </div>
                <div class="geo_json_cont">
                    {{ geoJsonData_u }}
                </div>
            </div>
        </div>
        <div class="map">
            <map-range :download-tips="downloadTips" @change="search"></map-range>
            <div id="data_json_format">
                <div class="geo_json_title">
                    地图数据所需格式示例{{ pros_has?'':'   ###正在下载全部数据结构...' }}
                    <div class="geo_json_copy"><span @click="copyMapData('a')">复制mapdata_name</span> | <span @click="copyMapData('b')">复制mapdata_geo</span> | <span @click="copyMapData('c')">复制mapregion_name</span></div>
                </div>
                <div class="geo_json_cont">
                    <b>axchart元件库所需地图数据说明：</b><br/>
                    离线使用：左边的geoJSON文件为地图底图，mapdata_name为构建数据的区域名称，geocoord_map为区域名称对应到地图上的位置。<br/>
                    在线使用：提供adcode会加载对应区域在线地图，mapdata_name为构建数据的区域名称，geocoord_map在在线使用时不需要系统会自动获取。<br/>
                    地图上色：要在axchart中给各区域上色，可使用mapregion_name，里面提到的区域都是当前地图支持上色的区域。<br/>
                    <span style="color:#ff6900">内容较长，请耐心滚动。</span><br/>
                    <b>在线加载的区域adcode: </b>{{ cur_code }}<br/>
                    <b>支持设置数据的区域mapdata_name:</b><br/>
                    {{ mapdata_name }}
                    <br/><b>数据区域对应位置信息mapdata_geo:</b><br/>
                    {{ geocoord_map }}
                    <br/><b>支持设置颜色的区域mapregion_name:</b><br/>
                    {{ mapregion_name }}
                    
                </div>
            </div>
        </div>
        <div class="tips" v-show="isShowTips">{{ tipmsg }}</div>
        <div class="axchart"><a href="http://www.pmlab.top" target="_blank"><img src="./images/axchart_word_white_logo.png" /></a></div>
    </div>
</template>

<script>
    import JSZip from 'jszip'
    import saveAs from './saveAs'
    import MapRange from "./MapRange";

    export default {
        name: "demo",
        components: {
            // Github,
            // MoneyDialog,
            MapRange},
        data() {
            return {
                cityName: '中国',
                areaCode: 10000,
                cur_code: 10000,
                geoJsonData: '',
                geoJsonData_u: '',
                echartsMap: null,
                map: null,
                uimap: null,
                district: null,
                polygons: [],
                cityCode: 100000,
                citySelect: null,
                districtSelect: null,
                opts: {},
                areaData: {},
                mapData: [],
                geocoord_map: {},
                mapdata_name: [],
                mapregion_name: [],
                allGeocoord_map: [],
                pros_has:0,
                zip: {},//打包zip
                codeList: [],
                isCodeListLoadComplete: false,//codeList是否全部获取完毕
                downloadTips: '下载全国geoJson数据',//下载进度提示
                tipmsg: '正在下载',
                isShowTips: false,//是否显示下载提示
            }
        },
        mounted() {
            //实例化zip对象
            // this.zip = new JSZip();
            var _this = this;

            this.citySelect = document.getElementById('city');
            this.districtSelect = document.getElementById('district');
            this.echartsMap = this.$echarts.init(document.getElementById('map'));
            this.echartsMap.on('click', this.echartsMapClick);

            this.map = new AMap.Map('container', {
                resizeEnable: true,
                center: [116.30946, 39.937629],
                zoom: 3
            });
            this.opts = {
                subdistrict: 1,   //返回下一级行政区
                showbiz: false  //最后一级返回街道信息
            };
            this.district = new AMap.DistrictSearch(this.opts);//注意：需要使用插件同步下发功能才能这样直接使用
            this.district.search('中国', (status, result) => {
                if (status == 'complete') {
                    this.getData(result.districtList[0], '', 100000);
                }
            });
        },
        // watch: {
        //     isCodeListLoadComplete(val) {
        //         if (val) {
        //             this.loadAllGeoJson();
        //         }
        //     }
        // },
        methods: {
            echartsMapClick(params) {//地图点击事件
                if(typeof params.data == 'undefined'){
                    this.showTips('该区域不支持直接点击下钻，请在右下角选择区域。');
                    return false;
                }
                this.$ba.trackEvent('echartsMap', '点击地图', `${params.data.name}-${params.data.cityCode}`);
                if (params.data.level == 'street') return;
                //清除地图上所有覆盖物
                for (var i = 0, l = this.polygons.length; i < l; i++) {
                    this.polygons[i].setMap(null);
                }
                this.cityName = params.data.name;
                this.cityCode = params.data.cityCode;
                this.district.setLevel(params.data.level); //行政区级别
                this.district.setExtensions('all');
                this.cur_code = this.cityCode;
                //行政区查询
                //按照adcode进行查询可以保证数据返回的唯一性
                this.district.search(this.cityCode, (status, result) => {
                    if (status === 'complete') {
                        this.getData(result.districtList[0], params.data.level, this.cityCode);
                    }
                });
            },
            loadMapData(areaCode) {
                var _this = this;
                AMapUI.loadUI(['geo/DistrictExplorer'], DistrictExplorer => {
                    //创建一个实例
                    var districtExplorer = window.districtExplorer = new DistrictExplorer({
                        eventSupport: true, //打开事件支持
                        map: this.map
                    });

                    districtExplorer.loadAreaNode(areaCode, (error, areaNode) => {
                        if (error) {
                            _this.geoJsonData_u = '不支持直接展示该级别地图，请选择上一级或下一级区域的geo。'
                            // console.error(error);
                            return;
                        }
                        let mapJson = {};
                        mapJson.features = areaNode.getSubFeatures();
                        this.loadMap(this.cityName, mapJson);
                        this.geoJsonData = mapJson;
                        this.geoJsonData_u = mapJson;
                    });
                });
            },
            showTips(msg) {
                this.tipmsg = msg;
                this.isShowTips = true;
                setTimeout(() => {
                    this.isShowTips = false;
                }, 3000)
            },
            showlongTips(msg){
                this.tipmsg = msg;
                this.isShowTips = true;
            },
            hidelongTips(msg){
                this.isShowTips = false;
            },
            copyGeoJson(){
                // alert(JSON.stringify(this.geoJsonData));
                var oInput = document.createElement('input');
                oInput.value = JSON.stringify(this.geoJsonData_u);
                document.body.appendChild(oInput);
                oInput.select(); // 选择对象
                document.execCommand("Copy"); // 执行浏览器复制命令
                oInput.className = 'oInput';
                oInput.style.display='none';
                this.showTips('复制成功！');
            },
            copyMapData(t){
                // alert(JSON.stringify(this.geoJsonData));
                var oInput = document.createElement('input');
                if(t=='a'){
                    oInput.value = JSON.stringify(this.mapdata_name);
                }else if(t=='b'){
                    oInput.value = JSON.stringify(this.geocoord_map);
                }else{
                    oInput.value = JSON.stringify(this.mapregion_name);
                }
                document.body.appendChild(oInput);
                oInput.select(); // 选择对象
                document.execCommand("Copy"); // 执行浏览器复制命令
                oInput.className = 'o1Input';
                oInput.style.display='none';
                this.showTips('复制成功！');
            },
            getAllCoord(cb){
                var _this = this;
                if(this.allGeocoord_map.length > 0){
                    cb();
                }else{
                    var l_cg = JSON.parse(localStorage.getItem("all_coord_geo") || '[]');
                    if(l_cg.length>0){
                        this.allGeocoord_map = l_cg;
                        this.pros_has = 1;
                        cb();
                    }else{
                        this.getCoordGeo('中国',function(d){
                            _this.allGeocoord_map = d.districts[0].districts;
                            localStorage.setItem("all_coord_geo",JSON.stringify(_this.allGeocoord_map));
                            cb();
                        });
                    }
                }
            },
            getCoordGeo(code,cb) {
                var _this = this;
                $.getJSON('https://restapi.amap.com/v3/config/district?key=3aaf3f96a44995a3fc02de3390f3d08b&keywords='+code+'&subdistrict=3&extensions=base',function(d){
                    _this.pros_has = 1;
                    cb(d);
                })
            },
            loadAllGeoJson() {//通过codeList加载全部geoJson数据
                // console.log('开始加载geoJson数据');
                AMapUI.loadUI(['geo/DistrictExplorer'], DistrictExplorer => {

                    //创建一个实例
                    var districtExplorer = window.districtExplorer = new DistrictExplorer({
                        eventSupport: true, //打开事件支持
                        map: this.map
                    });
                    let mapJson = {};
                    for (let i in this.codeList) {
                        setTimeout(() => {
                            districtExplorer.loadAreaNode(this.codeList[i].code, (error, areaNode) => {
                                if (error) {
                                    this.codeList[i].geo = 'error';
                                    // console.log(`${this.codeList[i].name}--${this.codeList[i].code}，geo 数据获取失败，高德地图的锅^_^`)
                                } else {
                                    mapJson.features = areaNode && areaNode.getSubFeatures() || '';
                                    this.codeList[i].geo = mapJson;
                                    // console.log(`${this.codeList[i].level}--${this.codeList[i].name}--${this.codeList[i].code}，geo 数据获取成功，马上为你打包`)
                                }

                                if (this.codeList[i].level === 'province') {
                                    this.zip.file(`100000/${this.codeList[i].code}.geoJson`, JSON.stringify(mapJson));
                                } else {
                                    this.zip.file(`100000/${this.codeList[i].code.substring(0, 2)}0000/${this.codeList[i].code}.geoJson`, JSON.stringify(mapJson));
                                }

                                if (this.codeList.every(item => item.geo)) {
                                    // console.log('ziped');
                                    // let readme = `\r\n
                                    //      `;
                                    // this.zip.file(`readMe(sourceCode).txt`, readme);
                                    // this.downloadTips = '文件打包压缩中...';
                                    // this.zip.generateAsync({type: "blob"})
                                    //     .then((content) => {
                                    //         saveAs(content, "geoJson数据包.zip");
                                    //         this.downloadTips = '下载geoJson数据';
                                    //         this.isCodeListLoadComplete = false;
                                    //         this.$ba.trackEvent('echartsMap', '文件下载', '打包下载成功');
                                    //     });
                                }
                            });
                        }, 100 * i)
                    }
                });
            },
            loadMap(mapName, data) {
                if (data) {
                    this.$echarts.registerMap(mapName, data);
                    var option = {
                        visualMap: {
                            type: 'continuous',
                            range: [0,100],
                            inRange: {
                                color: ['#1890FF', '#ff6900'],
                                symbolSize: [0, 100]
                            },
                            color: '#fff',
                            textStyle: {
                                color: '#fff',
                            },
                            show: false
                        },
                        series: [{
                            name: '数据名称',
                            type: 'map',
                            roam: false,
                            mapType: mapName,
                            selectedMode: 'single',
                            showLegendSymbol: false,
                            visibility: 'off',
                            itemStyle: {
                                normal: {
                                    color: '#ccc',
                                    areaColor: '#B0E2FF',
                                    borderColor: '#eee',
                                    borderWidth: 1,
                                    label: {
                                        show: true,
                                        textStyle: {
                                            color: "rgb(249, 249, 249)"
                                        }
                                    }
                                },
                                emphasis: {
                                    areaColor: '#ff6900',
                                    borderColor: '#eee',
                                    areaStyle: {
                                        color: '#555'
                                    },
                                    label: {
                                        show: true,
                                        textStyle: {
                                            color: "rgb(249, 249, 249)"
                                        }
                                    }
                                }
                            },
                            data: this.mapData,
                        }]
                    };
                    this.echartsMap.setOption(option);
                }
            },
            getData(data, level, adcode) {
                var bounds = data.boundaries;
                if (bounds) {
                    for (var i = 0, l = bounds.length; i < l; i++) {
                        var polygon = new AMap.Polygon({
                            map: this.map,
                            strokeWeight: 1,
                            strokeColor: '#0091ea',
                            fillColor: '#80d8ff',
                            fillOpacity: 0.25,
                            path: bounds[i]
                        });
                        this.polygons.push(polygon);
                    }
                    this.map.setFitView();//地图自适应
                }

                //清空下一级别的下拉列表
                if (level === 'province') {
                    this.citySelect.innerHTML = '';
                    this.districtSelect.innerHTML = '';
                } else if (level === 'city') {
                    this.districtSelect.innerHTML = '';
                }

                //封装axchart所需的数据格式
                //取当前code下二级的数据，如果为市级则取下一级
                var yy={};
                var xx=[];
                var zz=[];
                var _this = this;
                this.getAllCoord(function(){
                    if(adcode == 100000){
                        _this.allGeocoord_map.forEach(element => {
                            yy[element.name] = element.center.split(',').map(et=>{return Number(et)});
                            xx.push(element.name);
                            zz.push(element.name);
                            element.districts.forEach(ele => {
                                yy[ele.name] = ele.center.split(',').map(et=>{return Number(et)});
                                xx.push(ele.name);
                                ele.districts.forEach(el => {
                                    yy[el.name] = el.center.split(',').map(et=>{return Number(et)});
                                    xx.push(el.name);
                                })
                            })
                        });
                    }else{
                        if(level == 'province'){
                            _this.allGeocoord_map.forEach(element=>{
                                if(element.adcode == adcode){
                                    element.districts.forEach(ele=>{
                                        yy[ele.name] = ele.center.split(',').map(et=>{return Number(et)});
                                        xx.push(ele.name);
                                        zz.push(ele.name);
                                        ele.districts.forEach(el => {
                                            yy[el.name] = el.center.split(',').map(et=>{return Number(et)});
                                            xx.push(el.name);
                                        })
                                    })
                                }
                            })
                        }else if(level == 'city'){
                            _this.allGeocoord_map.forEach(element=>{
                                element.districts.forEach(ele=>{
                                    if(ele.adcode == adcode){
                                        ele.districts.forEach(el => {
                                            yy[el.name] = el.center.split(',').map(et=>{return Number(et)});
                                            xx.push(el.name);
                                            zz.push(el.name);
                                        })
                                    }
                                })
                            })
                        }else{
                            _this.allGeocoord_map.forEach(element=>{
                                element.districts.forEach(ele=>{
                                    ele.districts.forEach(el=>{
                                        if(el.adcode == adcode){
                                            $.getJSON('https://restapi.amap.com/v3/config/district?key=3aaf3f96a44995a3fc02de3390f3d08b&keywords='+adcode+'&subdistrict=3&extensions=base', function(eld){
                                                zz.push(eld.districts[0].name);
                                                eld.districts[0].districts.forEach(le=>{
                                                    yy[le.name] = le.center.split(',').map(et=>{return Number(et)});
                                                    xx.push(le.name);
                                                })
                                            })
                                        }
                                    })
                                })
                            })
                        }
                    }
                })
                this.geocoord_map = yy;
                this.mapdata_name = xx;
                this.mapregion_name = zz;

                // console.log(data)
                var subList = data.districtList;
                if (subList) {
                    var contentSub = new Option('--请选择--');
                    var curlevel = subList[0].level;
                    var curcenter = subList[0].center;
                    if (curlevel === 'street') {
                        let mapJsonList = this.geoJsonData.features;
                        let mapJson = {};
                        for (let i in mapJsonList) {
                            if (mapJsonList[i].properties.name == this.cityName) {
                                mapJson.features = [].concat(mapJsonList[i]);
                            }
                        }
                        this.mapData = [];
                        this.mapData.push({name: this.cityName, value: Math.random() * 100, level: curlevel, longitude: curcenter.lng, latitude:curcenter.lat});
                        this.loadMap(this.cityName, mapJson);
                        this.geoJsonData_u = mapJson;
                        this.hidelongTips();
                        return;
                    }
                    var curList = document.querySelector('#' + curlevel);
                    curList.add(contentSub);
                    this.mapData = [];
                    for (var i = 0, l = subList.length; i < l; i++) {
                        var name = subList[i].name;
                        var cityCode = subList[i].adcode;
                        var center = subList[i].center;
                        this.mapData.push({
                            name: name,
                            value: Math.random() * 100,
                            cityCode: cityCode,
                            level: curlevel,
                            longitude: center.lng,
                            latitude: center.lat
                        });
                        var levelSub = subList[i].level;
                        contentSub = new Option(name);
                        contentSub.setAttribute("value", levelSub);
                        contentSub.center = subList[i].center;
                        contentSub.adcode = subList[i].adcode;
                        curList.add(contentSub);
                    }
                    this.loadMapData(adcode);
                    this.areaData[curlevel] = curList;
                }
                this.hidelongTips();
            },
            search(area) {
                this.showlongTips('加载地图数据...')
                let obj = this.areaData[area];
                //清除地图上所有覆盖物
                for (var i = 0, l = this.polygons.length; i < l; i++) {
                    this.polygons[i].setMap(null);
                }
                var option = obj[obj.options.selectedIndex];
                var keyword = option.text; //关键字
                var adcode = option.adcode;
                this.cur_code = adcode;
                if(typeof adcode == 'undefined'){
                    this.hidelongTips();
                }
                this.cityName = keyword;
                this.cityCode = adcode;
                this.$ba.trackEvent('echartsMap', '筛选地图', `${this.cityName}-${this.cityCode}`);
                this.district.setLevel(option.value); //行政区级别
                this.district.setExtensions('all');
                //行政区查询
                //按照adcode进行查询可以保证数据返回的唯一性
                this.district.search(adcode, (status, result) => {
                    // console.log(result);
                    if (status === 'complete') {
                        this.getData(result.districtList[0], obj.id, adcode);
                    }
                });
            }
        }
    }
</script>

<style lang="stylus" scoped>

    * {
        font-size 14px
    }

    .body {
        display flex
        width 100%
    }

    .map, .echarts {
        width 0
        flex 1
    }

    .echarts {
        background: rgba(0,0,0,.8)
        background-size 100% 100%
    }

    #map {
        width 100%
        height 65vh
    }
    #geo_json, #data_json_format {
        width 100%
        height 35vh
        background #f5f5f5
        border 1px solid #eee
        position relative
    }
    .geo_json_title{
        position absolute
        top 0px
        left 0px
        right 0px
        color #000
        font-weight 700
        padding 10px 15px
        border-bottom 1px solid #eee
        background #fff
    }
    .geo_json_copy{
        position absolute
        right 15px
        top 10px
        height 30px
        cursor pointer
        font-size 12px
        color #555
    }
    .geo_json_copy span{
        font-size 12px
        color #555
    }
    .geo_json_cont{
        height 35vh
        padding 55px 15px 15px 15px
        color #555
        font-size 12px
        overflow-y scroll
    }

    .axchart{ 
        position fixed
        top 10px
        left 25px
        width 100px
    }
    .axchart a{
        display block
        width 100%
    }
    .axchart a img{
        width 100%
    }

    .tips {
        position fixed
        bottom 50%
        left 50%
        padding 10px 15px
        border-radius 5px
        color #fff
        background rgba(0, 0, 0, .8)
        z-index 999
        transform: translate(-50%, -50%);
    }
</style>
